export enum CouponTemporalUnit {
  Undefined = 'Undefined',
  Day = 'Day',
  Week = 'Week',
  Month = 'Month',
  Year = 'Year',
}

// Export array of values for PropTypes compatibility
export const CouponTemporalUnits = Object.values(CouponTemporalUnit);
